import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8626a670"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Scarica Allegati", -1))
const _hoisted_2 = ["onClick"]

import { Esami } from "@/../../EshJSLib/models/patient";
import { onMounted } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { Modal } from "flowbite-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'esamiDownload',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const store = patientStore();
const { patient } = storeToRefs(store);
let esami = ref({} as Esami);
const alertConfirmMessage = ref<null | string>(null);
const showConfirm = ref(false);
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
let errors = ref([]);

onMounted(() => {
  errors.value = [];  
  initFlowbite();
});



function openModal(message: string, esamiinput: Esami): Promise<boolean> {
  esami.value = esamiinput;
  alertConfirmMessage.value = message;
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });

}

function download(row) {
    store.fetchDownloadUrl(row).then((data) => {
      window.open(data.data as unknown as URL, "_blank");
    })
    resolvePromise(true);
  }

function closeModal() {
  showConfirm.value = false
  if (!resolvePromise) return;
         resolvePromise(false);
  emit("cancel");
  
}

__expose({ openModal });


return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        onClose: closeModal
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(esami).allegati, (item, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (download(_unref(esami).id_allegati[key]))
              }, _toDisplayString((item)), 9, _hoisted_2)
            ]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})